export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('authUser'));
    if (user && user.apiToken) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}
